import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { Programs, Products, Features, Flows, Feature } from 'bff/models/product';
import { Activities, Codes, Bulletin, Inscats, Inscat, Activity, Recommands, RecommandData } from 'bff/models/info';
import { Links, Link } from 'bff/models/link';
import { InsType } from 'constants/enums/insType.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { BulletinType } from 'constants/enums/bulletinType.enum';
import _ from 'lodash';
import { PetInsHome } from './types';

/**
 * @description 取得寵物險商品首頁初始化資料
 */
const fetchInitSetting = async (programId:string): Promise<PetInsHome> => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const programIdReq = commonService.getApiReqData({ PROGRAM_ID: programId || '' });

  type PetProdLink = {
    I06 : Link[]
  };

  const result:PetInsHome = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchProgramByInsTypeId(programIdReq, reqConfig, InsType.Pet),
    apiService.fetchProductByInsTypeId(baseReq, reqConfig, InsType.Pet),
    apiService.fetchFeatureByInsTypeId(baseReq, reqConfig, InsType.Pet),
    apiService.fetchFlowByInsTypeId(baseReq, reqConfig, InsType.Pet),
    apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, InsType.Pet),
    apiService.fetchLinkByCategory(baseReq, reqConfig, InsType.Pet),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CREDITCARD_BANK),
    apiService.fetchAnnounces(baseReq, reqConfig, BulletinType.InsType, InsType.Pet),
    apiService.fetchRecommands(baseReq, reqConfig, InsType.Pet),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([
    inscatsRes, programsRes, productsRes, featuresRes, flowsRes, activitiesRes, serviceLinksRes, creditCardCodeRes, bulletinRes, petRecommandsRes, UICodeRes]) => {
    const inscatsBaseRes:BaseRes<Inscats> = { ...inscatsRes };
    const inscatRes = _.find(inscatsBaseRes.TRANRS.INSURANCE_CATEGORY, (inscat:Inscat) => inscat.INS_TYPE_ID === InsType.Pet) as Inscat;
    const programsBaseRes:BaseRes<Programs> = { ...programsRes };
    const productsBaseRes:BaseRes<Products> = { ...productsRes };
    const featuresBaseRes:BaseRes<Features> = { ...featuresRes };
    const flowsBaseRes:BaseRes<Flows> = { ...flowsRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const serviceLinksBaseRes:BaseRes<Links<PetProdLink>> = { ...serviceLinksRes };
    const creditCardCodeBaseRes:BaseRes<Codes> = { ...creditCardCodeRes };
    const bulletinBaseRes:BaseRes<Bulletin> = { ...bulletinRes };
    const petRecommandsBaseRes:BaseRes<Recommands> = { ...petRecommandsRes };
    const UICodeBaseRes:BaseRes<Codes> = { ...UICodeRes };

    const res:PetInsHome = {
      inscat: { ...inscatRes },
      programs: commonService.arrayTypeReturn(programsBaseRes.TRANRS.PROGRAMS),
      products: commonService.arrayTypeReturn(productsBaseRes.TRANRS.PRODUCT),
      features: featuresBaseRes.TRANRS.FEATURE ? [...featuresBaseRes.TRANRS.FEATURE.sort((first:Feature, second:Feature) => first.SHOW_ORDER - second.SHOW_ORDER)] : new Array(0),
      flows: commonService.arrayTypeReturn(flowsBaseRes.TRANRS.FLOWS),
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      },
      serviceLinks: serviceLinksBaseRes.TRANRS.LINKS ? [...serviceLinksBaseRes.TRANRS.LINKS.I06] : new Array(0),
      creditCardCode: commonService.arrayTypeReturn(creditCardCodeBaseRes.TRANRS.CODES),
      bulletin: bulletinBaseRes.TRANRS.BULLETIN ? { ...bulletinBaseRes.TRANRS } : { BULLETIN: {} } as Bulletin,
      UICode: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      petRecommands: petRecommandsBaseRes.TRANRS.RECOMMANDS ? petRecommandsBaseRes.TRANRS.RECOMMANDS.find((recommandData: RecommandData) => recommandData.INS_TYPE_ID === InsType.Pet) : {},
      programId: ''
    };

    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
